import { styled } from 'styled-components';

import { colors } from 'src/css/theme';

// The chrome the two camera steps share: the heading block, the peer-action row, and the fullscreen preview. Both
// open the rear camera and show a bounded preview; only what they do with the frames differs, so the shutter and the
// continuous decode stay in their own components.

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Prompt = styled.h2`
  color: black;
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
`;

// Longer copy than the other steps carry, so it sets a line height.
export const Hint = styled.p`
  color: var(--color-gray-70);
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0;
`;

// Two equal halves; auto-fit, so below ~21rem the row becomes one full-width column rather than
// wrapping the longer label inside the buttons.
export const Actions = styled.div`
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));

  /* Alone while scanning, when the upload action is hidden. */
  > button:only-child {
    grid-column: 1 / -1;
  }

  > button {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    min-width: 0;
    width: 100%;
  }
`;

export const ActionIcon = styled.span`
  display: inline-flex;
`;

// Fullscreen while the camera is open: inline at container width the 1080p preview rendered into
// ~330px on a phone. Mounted only while open, so the camera indicator matches what the screen does.
export const CameraOverlay = styled.div<{ $visible: boolean }>`
  align-items: center;
  background: ${colors.realBlack};
  bottom: 0;
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  left: 0;
  padding: 0.75rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 20;
`;

// Shrink-wraps the video so an overlaid guide's percentages resolve against the rendered image.
export const OverlayFrame = styled.div`
  display: flex;
  min-height: 0;
  position: relative;
`;

// No object-fit: the element box has to stay the image box, or a guide stops marking decoded pixels.
export const OverlayVideo = styled.video`
  background-color: ${colors.realBlack};
  display: block;
  max-height: 100%;
  max-width: 100%;
`;

export const OverlayActions = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: min(22rem, 100%);
`;
